/**
 * Copies the value to the clipboard and invokes `callback` if provided
 * @param value The value to copy to the clipboard
 * @param callback The function to invoke after the value has been copied
 * @param timeout The amount of time to wait before invoking the callout (default is 1 second)
 */
export function copyToClipboard(value: string, callback?: () => void, timeout = 1000) {
  navigator.clipboard.writeText(value)

  if (callback) {
    setTimeout(() => {
      callback()
    }, timeout)
  }
}
